import React from 'react';

import ComparisonIcon from './ComparisonIcon';
import TranscriptionIcon from './TranscriptionIcon';
import BoxAnnotationIcon from './BoxAnnotationIcon';
import LineAnnotationIcon from './LineAnnotationIcon';
import DataCollectionIcon from './DataCollectionIcon';
import ImageAnnotationIcon from './ImageAnnotationIcon';
import PointAnnotationIcon from './PointAnnotationIcon';
import VideoAnnotationIcon from './VideoAnnotationIcon';
import LidarAnnotationIcon from './LidarAnnotationIcon';
import CuboidAnnotationIcon from './CuboidAnnotationIcon';
import PolygonAnnotationIcon from './PolygonAnnotationIcon';
import LidarSegmentationIcon from './LidarSegmentationIcon';
import TextCategorizationIcon from './TextCategorizationIcon';
import AudioTranscriptionIcon from './AudioTranscriptionIcon';
import ImageCategorizationIcon from './ImageCategorizationIcon';
import SemanticSegmentationIcon from './SemanticSegmentationIcon';

interface TaskTypeIconProps {
  type: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

// eslint-disable-next-line complexity
const TaskTypeIcon: React.FC<TaskTypeIconProps> = ({ type, style, disabled }) => {
  const color = disabled ? '#636363' : undefined;

  if (type === 'sensor-fusion-cuboids' || type === 'lidarannotation' || type === 'lidarlinking') {
    return <LidarAnnotationIcon color={color} />;
  }

  if (type === 'sensor-fusion-segmentation' || type === 'lidarsegmentation') {
    return <LidarSegmentationIcon color={color} />;
  }

  if (type === 'semantic-segmentation' || type === 'segmentannotation') {
    return <SemanticSegmentationIcon color={color} />;
  }

  if (type === 'cuboids' || type === 'cuboidannotation') {
    return <CuboidAnnotationIcon color={color} />;
  }

  if (type === 'polygonannotation') {
    return <PolygonAnnotationIcon color={color} />;
  }

  if (type === 'twod-boxes' || type === 'boxannotation' || type === 'annotation') {
    return <BoxAnnotationIcon color={color} />;
  }

  if (type === 'lineannotation') {
    return <LineAnnotationIcon color={color} />;
  }

  if (type === 'categorization' || type === 'imagecategorization') {
    return <ImageCategorizationIcon color={color} style={style} />;
  }

  if (type === 'textcategorization') {
    return <TextCategorizationIcon color={color} style={style} />;
  }

  if (type === 'comparison') {
    return <ComparisonIcon color={color} style={style} />;
  }

  if (type === 'datacollection' || type === 'genericdatacollection') {
    return <DataCollectionIcon color={color} style={style} />;
  }

  if (type === 'audiotranscription') {
    return <AudioTranscriptionIcon color={color} style={style} />;
  }

  if (type === 'transcription') {
    return <TranscriptionIcon color={color} style={style} />;
  }

  if (type === 'pointannotation') {
    return <PointAnnotationIcon color={color} style={style} />;
  }

  if (['videoboxannotation', 'video-annotation', 'videoannotation'].includes(type)) {
    return <VideoAnnotationIcon color={color} style={style} />;
  }

  return <ImageAnnotationIcon color={color} />;
};

export default TaskTypeIcon;
